import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryCard } from '@feathr/components';
import { localTime, TimeFormat } from '@feathr/hooks';

interface IMetaConnectionDetailsProps {
  connectedByName?: string;
  connectedByEmail?: string;
  connectedAt?: string;
}

function MetaConnectionDetails({
  connectedByName,
  connectedByEmail,
  connectedAt,
}: Readonly<IMetaConnectionDetailsProps>): JSX.Element {
  const { t } = useTranslation();

  const formattedDate = connectedAt ? localTime(connectedAt, TimeFormat.longDateTime) : '—';

  return (
    <SummaryCard>
      <SummaryCard.Header>{t('Connection Details')}</SummaryCard.Header>
      <SummaryCard.Item label={t('Connected By')}>
        {connectedByName || connectedByEmail || '—'}
      </SummaryCard.Item>
      <SummaryCard.Item icon={faCalendar} label={t('Connected On')}>
        {formattedDate}
      </SummaryCard.Item>
    </SummaryCard>
  );
}

export default MetaConnectionDetails;
